import React from 'react';
import { colors } from '@styles/colors';

function Advertencia({ mensaje = 'No se encontraron resultados', ancho = '63vh', marginTop = '2vh' }) {
  return (
    <div style={{
      backgroundColor: colors.warnBg,
      border: `0.2vh solid ${colors.warnBorder}`,
      borderRadius: '1vh',
      padding: '1.5vh',
      marginTop: marginTop,
      display: 'flex',
      alignItems: 'center',
      gap: '1vh',
      boxShadow: `0 0.4vh 1.6vh ${colors.warnShadow}`,
      width: ancho
    }}>
      <div style={{
        fontSize: '2.4vh',
        color: colors.warnIcon,
        fontWeight: '700'
      }}>
        ⚠️
      </div>
      <div style={{
        flex: 1,
        color: colors.warnText,
        fontSize: '1.6vh',
        fontFamily: 'Inter',
        fontWeight: 500
      }}>
        {mensaje}
      </div>
    </div>
  );
}

export default Advertencia;